export class ViewGatewayDashboard{
    datafor: string;
    startdate: string;
    enddate: string;
    mode: string;
}
export class PaymentTxnsAmountInputForBoth{
    type: string;
    datafor: string;
    startdate: string;
    enddate: string;
    mode: string;
    ekpay_id: string;
}
export class PaymentTxnsAmountOutputForBoth{
    gateway_name: string[];
    total_amount: number[];
}
export class PaymentSuccessFailureOutputForBoth{
    gateway_name: string[];
    success: number[];
    fail: number[];
}
export class TopRecordsInput{
    recordfor: string;
    datafor: string;
    startdate: string;
    enddate: string;
    mode: string;
}
export class TopRecordsOutput{
    data_for: string;
    reason: string;
    record_for: string;
    response: string;
    top_records: string[];
}
export class RegisteredGatewaysInput {
    datafor: string;
    startdate: string;
    enddate: string;
    mode: string;
    ekpay_id: string;
}
export class EkpayRegisteredGateway {
    fail_rate: number;
    gwt_charges: number;
    success_rate: number;
    txns_amount: number;
    gwt_name: string;
}

export class RegisteredGatewaysOutput {
    data_for: string;
    reason: string;
    response: string;
    ekpay_registered_gateways: EkpayRegisteredGateway[];
}


// WEBPACK FOOTER //
// ./src/app/dashboards/reconcilliation-dashboard/gateway-Graphs.ts